export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <h4 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Pacifico, serif' }}>
              Vision Map
            </h4>
            <p className="text-gray-400">
              あなたの夢を視覚化し、<br />
              実現への第一歩を踏み出しましょう
            </p>
          </div>

          <div>
            <h5 className="font-bold mb-4">開催情報</h5>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-center gap-2">
                <i className="ri-calendar-line text-teal-400"></i>
                <span>2025年12月28日</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-teal-400"></i>
                <span>13:00-17:00</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-teal-400"></i>
                <span>大阪・梅田</span>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="font-bold mb-4">お問い合わせ</h5>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-teal-400"></i>
                <span>info@visionmap.jp</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-teal-400"></i>
                <span>06-1234-5678</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2025 Vision Map Seminar. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
